import { ref } from "vue";
import { useWecomaIntegration } from "@allwyn/gdpr/utils/use-wecoma-integration";
import { Lottery } from "@allwyn/lotteries/js/models/lottery";
import { httpClient } from "@allwyn/utils/http-clients/http-client";
import { useFloatingDisplay } from "./floating-display-logic";
import { FloatingDto } from "./model/floating-dto";

export const displayExponea = ref(true);

export async function useFloatingOnOnlineBet(lottery: Lottery) {
    const { marketingConsented } = useWecomaIntegration();
    const consented = await marketingConsented();
    if (!consented) return;

    const floatingResponse = await httpClient.get<FloatingDto>(`/api/floating-element/${lottery}`);
    displayExponea.value = false;

    if (!floatingResponse.data) return;

    const { analyticsCodeName, loggedIn } = floatingResponse.data;

    const display = useFloatingDisplay(analyticsCodeName, loggedIn);
    if (!display.shouldShow(true)) return;

    (await import("./mount-floating")).mount(floatingResponse.data);
}

export async function useExponeaFloatingById(floatingID: number) {
    const { marketingConsented } = useWecomaIntegration();
    const consented = await marketingConsented();
    if (!consented) return;

    const floatingResponse = await httpClient.get<FloatingDto>(`/api/floating-element/exponea/${floatingID}`);

    if (!floatingResponse.data) return;

    if (displayExponea.value) {
        (await import("./mount-floating")).mount(floatingResponse.data);
    }
}
